import { render, staticRenderFns } from "./onRowDoubleClick-editor.vue?vue&type=template&id=7e79e906&scoped=true&"
import script from "./onRowDoubleClick-editor.vue?vue&type=script&lang=js&"
export * from "./onRowDoubleClick-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e79e906",
  null
  
)

export default component.exports